export enum EWalletDynamicDataType {

    Text = 1,
    Number = 2,
    DropDown = 3,
    Hidden = 4,
}
